/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { object, func } from 'prop-types';
import RecipientList from './RecipientList';
import SearchFilter from './SearchFilter';

const RecipientListContainer = ({ recipientData, setIsRecipientListVisible, setOtherOption, handleOptionChange }) => {
    const [recipients, setRecipients] = useState(recipientData);
    return (
        <>
            <div>
                <SearchFilter recipients={recipients} setRecipients={setRecipients} recipientData={recipientData}/>
            </div>
            <RecipientList recipients={recipients} setIsRecipientListVisible={setIsRecipientListVisible} setOtherOption={setOtherOption} handleOptionChange={handleOptionChange}/>
        </>
    );
};

RecipientListContainer.propTypes = {
    recipientData: object.isRequired,
    setIsRecipientListVisible: func,
    setOtherOption: func,
    handleOptionChange: func.isRequired,

};

export default (RecipientListContainer);
